import { Component, OnInit } from '@angular/core';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppLocalization } from '../../shared/entities/app-localization';
import { Catalog } from './entities/product-entity';
import { ProductsService } from './services/products-service/products.service';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss'],
  standalone: false
})
export class ProductsComponent implements OnInit {
  appStrings: AppLocalization;
  catalogs: Catalog[];

  constructor(
    private productsService: ProductsService,
    private appInfoService: AppInfoService,
  ) { }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.catalogs = this.productsService.catalogs;
  }
}
